import { useEffect, type RefObject } from 'react';
import { useCameraStore } from '@/store/cameraStore';
import { cameraMatrix } from '@/core/coordinates/coordinateSystem';
import { toCssMatrix } from '@/core/geometry/transform';
import { useEngine } from '@/app/EngineContext';

/**
 * Applies the camera to the world layer imperatively. Panning and zooming therefore
 * never re-render the React tree: one subscription writes one `transform` per frame.
 */
export const useCameraTransform = (worldRef: RefObject<HTMLElement | null>): void => {
  const { frames } = useEngine();
  useEffect(() => {
    const apply = () => {
      const world = worldRef.current;
      if (world) world.style.transform = toCssMatrix(cameraMatrix(useCameraStore.getState().camera));
    };
    apply();
    return useCameraStore.subscribe((s, prev) => {
      if (s.camera !== prev.camera) frames.schedule(apply);
    });
  }, [frames, worldRef]);
};
